__webpack_require__.p = "//static.m2.ru//search/ba6113a0/";